import { useDataGridContext } from '@cmg/data-grid';
import { useEffect, useState } from 'react';

import { useEnumOptions } from '../../../../../common/hooks/useEnumOptions';
import { OfferingType } from '../../../../../graphql/__generated__';
import type { CalendarGridContext } from '../CalendarGrid.model';

export type UseCalendarGridDataContextProps = Readonly<{
  withCustomSectors?: boolean;
}>;

const EXCLUDED_OFFERING_TYPES = [OfferingType.Atm, OfferingType.RegisteredDirect];

export const useCalendarGridDataContext = ({
  withCustomSectors = false,
}: UseCalendarGridDataContextProps = {}) => {
  const { refreshCells } = useDataGridContext();

  const {
    regions,
    countries,
    exchangeMics,
    sectors,
    customSectors,
    offeringTypes,
    offeringStatuses,
  } = useEnumOptions({ excludedOfferingTypes: EXCLUDED_OFFERING_TYPES });

  const [gridContext, setGridContext] = useState<CalendarGridContext>({
    regions,
    countries,
    exchangeMics,
    sectors,
    customSectors,
    offeringTypes,
    offeringStatuses,
    withCustomSectors,
  });

  useEffect(() => {
    refreshCells();
  }, [gridContext.withCustomSectors, refreshCells]);

  useEffect(() => {
    // Set the grid context with the regions data
    setGridContext(context => ({
      ...context,
      regions,
      countries,
      exchangeMics,
      sectors,
      customSectors,
      offeringTypes,
      offeringStatuses,
      withCustomSectors,
    }));
  }, [
    countries,
    customSectors,
    exchangeMics,
    offeringStatuses,
    offeringTypes,
    regions,
    sectors,
    setGridContext,
    withCustomSectors,
  ]);

  return gridContext;
};
